import vSelect from 'vue-select';
import track from "./track";

export default {

    components: {
        vSelect
    },

    data() {
        return {
            form: {
                name: null,
                email: null,
                entity: null,
                street: null,
                number: null,
            },
            loading: {
                check: false,
            },
            status: null,
            nameHasError: false,
            emailHasError: false,
            entityHasError: false,
            streetHasError: false,
            numberHasError: false,
            privacy_alert: true,
            showAfter: false,
            accept: false,
            acceptError: false,
            query: null,
            debounceEntities: null,
            gis: {
                entities: [],
            },
            inputType: 0
        }
    },

    methods: {

        checkEmail () {
            if (!this.form.email) return false
            let re = /[@]/
            return re.test(this.form.email)
        },
        checkPhone () {
            if (!this.form.email) return false
            let re = /^\d{9}$/
            return re.test(this.form.email)
        },
        showErrors(){
            // if (!this.checkEmail()) {
            //     this.emailHasError = true;
            // }
            if (!this.checkPhone()) {
                this.emailHasError = true;
            }else {
                this.emailHasError = false;
            }
            if (!this.form.name) {
                this.nameHasError = true;
            }
            if (!this.query) {
                this.entityHasError = true;
            }
            // if (!this.form.street) {
            //     this.streetHasError = true;
            // }
            // if (!this.form.number) {
            //     this.numberHasError = true;
            // }
            if (!this.accept) {
                this.privacy_alert = false;
            }

        },
        fetchEntities(value) {
            if (!value || value.length <=2) {
                this.gis.entities = []
                return;
            }
            clearTimeout(this.debounceEntities);
            this.debounceEntities = setTimeout(async () => {
                try {
                    let res = await axios.post('/coverage/search', {
                        type: 'ent',
                        name: value,
                        coverage_type: 'old'
                    })

                    const data = res.data?.data ?? [];
                    this.gis.entities = data.map(item => ({ label: item.n,  code: item.c, level: item.l }));

                } catch (e) {
                    console.error(e.message)
                    this.gis.entities = [];
                }
            }, 250);
        },

        async check() {
            if(!this.canSearch){
                return
            }
            this.status = null
            this.loading.check = true
            this.showAfter = true
            this.form.entity = this.query
            trackFbq('track', 'Lead')
            try{
                if(window.dataLayer){
                    dataLayer.push({'event': 'homeLeadFormCompleted'})
                }
            } catch (error) {
                console.error(error)
            }
            try {
                let params = {
                    name: this.form.name,
                    email: this.form.email,
                    entity_code: this.form.entity.code,
                    entity_level: this.form.entity.level,
                    street_name: this.form.street,
                    number_name: this.form.number,
                    coverage_type: 'old',
                }
                let cookies = document.cookie;
                if(cookies.includes("girona")){
                    track.event({
                        eventCategory: "girona",
                        eventAction: "check-coverage",
                        eventLabel: params.entity_code ?? "UNKNOWN"
                    })
                }else {
                    track.event({
                        eventCategory: "home",
                        eventAction: "check-coverage",
                        eventLabel: params.entity_code ?? "UNKNOWN"
                    });
                    window.criteo_q = window.criteo_q || [];
                    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                    window.criteo_q.push(
                        { event: "setAccount", account: 91391},
                        { event: "setSiteType", type: deviceType},
                        { event: "trackTransaction", id: Math.floor(Math.random()*99999999999)+1, item: [
                                {id: "1", price: "1", quantity: "1" }
                            ]}
                    );
                }
                let res = await axios.post('/coverage/landing', params)

                if (window.location.hostname === 'goufone.com') {
                    require('./floodCoverage')
                }

                this.status = res.data.data?.status ?? null
                this.address = res.data.data?.address ?? null

            } catch (e) {
                console.log("error", e.message)
                console.log(e.response.data.errors)
            } finally {
                this.loading.check = false
            }
        },

        reload() {
            this.loading.check = false
            this.status = null
            this.form.number = null
            this.form.entity = null
            this.gis.entities = []
            this.query = null
            this.form.street = null
            this.showAfter = false
            this.accept= false
        },
        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
    },

    watch: {
        status: function (newValue, oldValue){
            if(newValue){
                this.$refs.options.style.display = 'block'
            }else{
                this.$refs.options.style.display = 'none'
            }
        },
    },
    created() {
        this.inputType = new Date().getTime() % 2;
        this.coverageTypeVariable = this.getCookie("cobertura");
    },
    mounted() {
        this.$refs.options.classList.add('mounted')
        this.$refs.searching.classList.remove('hidden')
    },
    computed: {
        hasStatus() {
            return !!this.status
        },

        canSearch() {
            this.acceptError = false
            // if(!this.checkEmail()) return false
            if(!this.checkPhone()) {
                console.log('canSearch');
                this.emailHasError = true;
                return false
            }else {
                this.emailHasError = false;
            }
            if(!this.form.name) return false
            if(!this.query) return false
            // if(!this.form.street) return false
            if(!this.accept) {
                this.acceptError = true
                return false
            }
            return true
        },

        statusUnavailable() {
            return this.status === 'unavailable'
        },

        statusAvailable() {
            return this.status === 'available'
        },

        statusForecast() {
            return this.status === 'forecast'
        },

        statusReview() {
            return this.status === 'review'
        },
        coverageType(){
            return this.coverageTypeVariable;
        },
    }
}

